module.exports = {"140403001":"东街街道","140403002":"西街街道","140403003":"英雄南路街道","140403004":"英雄中路街道","140403005":"紫金街街道","140403006":"太行东街街道","140403007":"太行西街街道","140403008":"延安南路街道","140403009":"常青街道","140403010":"五马街道","140403011":"长北街道","140403012":"故县街道","140403100":"老顶山镇","140403101":"堠北庄镇","140403102":"大辛庄镇","140403103":"马厂镇","140403104":"黄碾镇","140403200":"西白兔乡","140403400":"长治市漳泽工业转型试验区管理委员会","140403401":"长治市老顶山旅游开发管理中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140403.json
// module id = 291
// module chunks = 0